import { DatePicker } from '@mui/x-date-pickers/DatePicker';

export { DatePicker };
export type { DatePickerProps } from '@mui/x-date-pickers/DatePicker';
export default DatePicker;
